/**
 * Portal color-mode options offered in the My Agency picker. `value` is the key
 * persisted to `agency.portalThemeMode`; the client portal (v2) renders in this
 * mode with no visitor-facing toggle.
 */
export const PORTAL_THEME_MODE_OPTIONS = [
  { value: 'dark', label: 'Dark' },
  { value: 'light', label: 'Light' },
];

export const PORTAL_THEME_MODES = PORTAL_THEME_MODE_OPTIONS.map(option => option.value);
